"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DettaglioInfoProcessoDashboardDtoToJSON = exports.DettaglioInfoProcessoDashboardDtoFromJSONTyped = exports.DettaglioInfoProcessoDashboardDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function DettaglioInfoProcessoDashboardDtoFromJSON(json) {
    return DettaglioInfoProcessoDashboardDtoFromJSONTyped(json, false);
}
exports.DettaglioInfoProcessoDashboardDtoFromJSON = DettaglioInfoProcessoDashboardDtoFromJSON;
function DettaglioInfoProcessoDashboardDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'numeroProcessiTotale': !runtime_1.exists(json, 'numeroProcessiTotale') ? undefined : json['numeroProcessiTotale'],
        'numeroProcessiSincrono': !runtime_1.exists(json, 'numeroProcessiSincrono') ? undefined : json['numeroProcessiSincrono'],
        'numeroProcessiAsincrono': !runtime_1.exists(json, 'numeroProcessiAsincrono') ? undefined : json['numeroProcessiAsincrono'],
        'numeroProcessiCampagna': !runtime_1.exists(json, 'numeroProcessiCampagna') ? undefined : json['numeroProcessiCampagna'],
        'percProcessiTotale': !runtime_1.exists(json, 'percProcessiTotale') ? undefined : json['percProcessiTotale'],
        'percProcessiSincrono': !runtime_1.exists(json, 'percProcessiSincrono') ? undefined : json['percProcessiSincrono'],
        'percProcessiAsincrono': !runtime_1.exists(json, 'percProcessiAsincrono') ? undefined : json['percProcessiAsincrono'],
        'percProcessiCampagna': !runtime_1.exists(json, 'percProcessiCampagna') ? undefined : json['percProcessiCampagna'],
    };
}
exports.DettaglioInfoProcessoDashboardDtoFromJSONTyped = DettaglioInfoProcessoDashboardDtoFromJSONTyped;
function DettaglioInfoProcessoDashboardDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'numeroProcessiTotale': value.numeroProcessiTotale,
        'numeroProcessiSincrono': value.numeroProcessiSincrono,
        'numeroProcessiAsincrono': value.numeroProcessiAsincrono,
        'numeroProcessiCampagna': value.numeroProcessiCampagna,
        'percProcessiTotale': value.percProcessiTotale,
        'percProcessiSincrono': value.percProcessiSincrono,
        'percProcessiAsincrono': value.percProcessiAsincrono,
        'percProcessiCampagna': value.percProcessiCampagna,
    };
}
exports.DettaglioInfoProcessoDashboardDtoToJSON = DettaglioInfoProcessoDashboardDtoToJSON;
